import { apiCall, API_CONFIG } from './api';
import { IS_ALFAJR } from '../constants/general';

export const bannerAPI = {
  // Create banner
  createBanner: async (bannerData) => {
    try {
      const formData = new FormData();

      formData.append('title', bannerData.title || '');
      formData.append('arabicTitle', bannerData.arabicTitle || '');
      formData.append('type', bannerData.type || 'deals_promotions');

      if (bannerData.image instanceof File) {
        formData.append('image', bannerData.image);
      }

      if (!IS_ALFAJR) {
        formData.append('description', bannerData.description || '');
        formData.append('color', bannerData.color || '');
        if (bannerData.icon instanceof File) {
          formData.append('icon', bannerData.icon);
        } else if (bannerData.clearIcon) {
          formData.append('clearIcon', 'true');
        }
      }

      formData.append('hasButton', String(bannerData.hasButton || false));
      formData.append('buttonName', bannerData.buttonName || '');
      formData.append('hasCountdown', String(bannerData.hasCountdown || false));
      formData.append('countdownTime', bannerData.countdownTime || '');
      formData.append('priority', bannerData.priority || 'normal');

      if (bannerData.applicationType === 'selected_categories') {
        formData.append('category', bannerData.category);
        formData.append('subCategory', bannerData.subCategory);
      }

      if (bannerData.applicationType === 'selected_products') {
        const productsFormatted = bannerData.products.map(productId => ({ id: String(productId) }));
        formData.append('products', JSON.stringify(productsFormatted));
      }

      if (bannerData.targetType === 'nationality') {
        formData.append('country', bannerData.country);
        if (bannerData.language) {
          formData.append('language', bannerData.language);
        }
      }

      return await apiCall(API_CONFIG.ENDPOINTS.BANNER_CREATE, {
        method: 'POST',
        body: formData
      });
    } catch (error) {
      console.error('Error creating banner:', error);
      throw error;
    }
  },

  // Update banner
  updateBanner: async (bannerId, bannerData) => {
    try {
      const formData = new FormData();

      formData.append('_id', bannerId);

      if (bannerData.title !== undefined) formData.append('title', bannerData.title);
      if (bannerData.arabicTitle !== undefined) formData.append('arabicTitle', bannerData.arabicTitle);
      if (bannerData.type) formData.append('type', bannerData.type);

      if (bannerData.image instanceof File) {
        formData.append('image', bannerData.image);
      }

      if (!IS_ALFAJR) {
        formData.append('description', bannerData.description || '');
        formData.append('color', bannerData.color || '');
        if (bannerData.icon instanceof File) {
          formData.append('icon', bannerData.icon);
        } else if (bannerData.clearIcon) {
          formData.append('clearIcon', 'true');
        }
      }

      if (bannerData.hasButton !== undefined) formData.append('hasButton', String(bannerData.hasButton));
      if (bannerData.buttonName !== undefined) formData.append('buttonName', bannerData.buttonName);
      if (bannerData.hasCountdown !== undefined) formData.append('hasCountdown', String(bannerData.hasCountdown));
      if (bannerData.countdownTime !== undefined) formData.append('countdownTime', bannerData.countdownTime || '');
      if (bannerData.priority !== undefined) formData.append('priority', bannerData.priority);

      if (bannerData.category) {
        formData.append('category', bannerData.category);
      } else {
        formData.append('category', '');
      }

      formData.append('subCategory', bannerData.subCategory);

      if (bannerData.products && Array.isArray(bannerData.products)) {
        const productsFormatted = bannerData.products.map(productId => ({ id: String(productId) }));
        formData.append('products', JSON.stringify(productsFormatted));
      } else {
        formData.append('products', JSON.stringify([]));
      }

      if (bannerData.targetType === 'nationality') {
        formData.append('country', bannerData.country || '');
        formData.append('language', bannerData.language || '');
      } else {
        formData.append('country', '');
        formData.append('language', '');
      }

      return await apiCall(API_CONFIG.ENDPOINTS.BANNER_UPDATE, {
        method: 'PUT',
        body: formData
      });
    } catch (error) {
      console.error('Error updating banner:', error);
      throw error;
    }
  },

  // Delete banner
  deleteBanner: async (bannerId) => {
    try {
      const endpoint = `${API_CONFIG.ENDPOINTS.BANNER_DELETE}${bannerId}`;
      const response = await apiCall(endpoint, {
        method: 'DELETE',
      });
      return response;
    } catch (error) {
      console.error('Error deleting banner:', error);
      throw error;
    }
  },

  // Get all banners
  getAllBanners: async (params = {}) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.BANNER_LIST, {
        method: 'POST',
        body: JSON.stringify(params)
      });
      return response;
    } catch (error) {
      console.error('Error fetching banners:', error);
      throw error;
    }
  },

  reorderBanners: async (reorderData) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.BANNER_REORDER, {
        method: 'PUT',
        body: JSON.stringify(reorderData)
      });
      return response;
    } catch (error) {
      console.error('Error reordering banners:', error);
      throw error;
    }
  },

  bulkUpdateBannerProducts: async (payload) => {
    try {
      const response = await apiCall(API_CONFIG.ENDPOINTS.BANNER_BULK_UPDATE, {
        method: 'POST',
        body: JSON.stringify(payload)
      });
      return response;
    } catch (error) {
      console.error('Error batch updating banners:', error);
      throw error;
    }
  }
};